// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCss from "../../../../bindings/BsCss.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as Theme from "../../../../css/Theme.bs.js";
import * as StaticImage from "../../../StaticImage.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

var container = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(165)),
      tl: {
        hd: BsCss.position("absolute"),
        tl: {
          hd: BsCss.bottom(BsCss.px(0)),
          tl: {
            hd: BsCss.left(BsCss.px(685)),
            tl: {
              hd: BsCss.media("(min-width: 1200px)", {
                    hd: BsCss.left(BsCss.px(785)),
                    tl: /* [] */0
                  }),
              tl: /* [] */0
            }
          }
        }
      }
    });

var imgWidth = Curry._1(BsCss.style, {
      hd: BsCss.width(BsCss.px(80)),
      tl: {
        hd: BsCss.height(BsCss.px(80)),
        tl: /* [] */0
      }
    });

var title = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(22)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(23)),
        tl: {
          hd: BsCss.color(Theme.Color.activeBlue),
          tl: {
            hd: BsCss.fontWeight("semiBold"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var subTitle = Curry._1(BsCss.style, {
      hd: BsCss.fontSize(BsCss.px(16)),
      tl: {
        hd: BsCss.lineHeight(BsCss.px(23)),
        tl: {
          hd: BsCss.color(Theme.Color.activeBlue),
          tl: {
            hd: BsCss.fontWeight("semiBold"),
            tl: {
              hd: BsCss.fontStyle("normal"),
              tl: /* [] */0
            }
          }
        }
      }
    });

var Styles = {
  container: container,
  imgWidth: imgWidth,
  title: title,
  subTitle: subTitle
};

function OneMillion(props) {
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(StaticImage.make, {
                            src: "/images/about/journey/smart_card_1.png",
                            alt: "prezzee smart card",
                            width: 80,
                            height: 61
                          }),
                      className: imgWidth
                    }),
                JsxRuntime.jsx("h4", {
                      children: "ONE MILLION",
                      className: title
                    }),
                JsxRuntime.jsx("h6", {
                      children: "eGift cards sold! Milestone achieved.",
                      className: subTitle
                    })
              ],
              className: container
            });
}

var Img;

var make = OneMillion;

export {
  Img ,
  Styles ,
  make ,
}
/* container Not a pure module */
